export default __webpack_public_path__ + "static/media/id.60118c48.svg";